import React, { useEffect, useMemo, useRef, useState } from "react";
import { Avatar, Button, Col, Form, Image, Row, Space, Tooltip } from "antd";

import { useAppDispatch, useAppSelector } from "redux/hooks";
import Notification from "components/common/notification/notification";

import { medicalExaminationService } from "api";
import { InputFields } from "../../../../../../components/common";
import { setButtonsHeader } from "redux/reducer/common";
import { mapOptions as InfoMapOptions } from "./BankAccount/BankAccount";
import columnsTable from "./Contact/Contact";
import { employeeService } from "api";
import {
  dataSoYeuLyLich,
  dataLyLichTuPhap,
  dataGiayKhaiSinh,
  dataGiayKhamSucKhoe,
  dataTheCanCuoc,
  dataXacNhanThuongChu,
  dataBangCap,
  dataXacNhanTienAn,
  dataKhaiSinhCon,
  dataChungChiHanhNghe,
  dataNghiHuu,
  dataKhac,
} from "./Profile/Profile.config";
import {
  setEmployee,
  setIdEmployee,
  setAdd,
  getDanToc,
  getNation,
  getTonGiao,
  searchEmployeeAPI,
  getBank,
  getNoiCap,
} from "redux/reducer/employee";
import TypographyCommon from "../../../../../ResidentialNurse/Treatment/tabs/TreatmentInfo/TypographyCommom/TypographyCommon";
import { FIELD_TYPE, FORMAT_TIME, tabKeys } from "../../../../../../types/enums";
import { Save, Cancel, edit } from "./ListButton/ListBotton";
import moment from "moment";
import dayjs from "dayjs";
import {
  formatDateToString,
  generateFileName,
} from "../../../../../../helper/common";
import { getImageSrc } from "../../../../../Receive/ExtendCard/config";
import { DownloadOutlined, UserOutlined } from "@ant-design/icons";
//import { fields as dataFields } from "./EmployeeInfo/config";
import Icons from "../../../../../../assets/icons";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import axiosClient from "api/axiosClient";
import { EMPLOYEE_MODE } from "types/enums/employee";
import { useLocation } from "react-router-dom";
import usePermission from "hooks/usePermission";
import { listGender, listMarriage } from "data/list";
const {
  INPUT,
  SELECT,
  DATE_DAY_INPUT,
  DATE_DISABLE_NO_DAY,
  DATE,
  COMBO_BOX,
  AUTO_COMPLETE,
  NUMBER,
  TEXT_AREA,
  CHECKBOX
} = FIELD_TYPE;
const Detail = () => {
  const handleQuocTich = (e) => {
    const quocTichValue = form.getFieldValue("quocTich");
   // console.log("quocTichValue",quocTichValue);
    const selectedQuocTich = employees.quocTichList.find(
      (item) => item.nameVN === quocTichValue
    );
   // console.log("selectedQuocTich",selectedQuocTich);
    if (selectedQuocTich) {
      form.setFieldsValue({ quocTichTA: selectedQuocTich.nameENG });
    }
    //console.log(form.getFieldValue("quocTich"));
  };
  const handleNoiCap = (e) => {
    const noiCapValue = form.getFieldValue("noiCap");
   // console.log("noiCapValue",noiCapValue);
    const selectedNoiCap = employees.noiCap.find(
      (item) => item.noiCap === noiCapValue
    );
   // console.log(employees.noiCap.find(item => item.noiCap));
    
   // console.log("selectedNoiCap",selectedNoiCap);
    if (selectedNoiCap) {
      form.setFieldsValue({ noiCapTA: selectedNoiCap.noiCapTA });
    }
   // console.log(form.getFieldValue("noiCap"));
  };
  const fields: any[] = [
    {
      type: INPUT,
      label: "Mã nhân viên",
      name: "maNhanVien",
      disable: true,
      rules: [
        { required: true, message: "Chưa nhập mã nhân viên" },
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
      ],
    },
    // {
    //     type: INPUT,
    //     label: "MNV Emp Code",
    //     name: "empCode",
    //     disable: true,
    //     rules: [{required: true, message: "Chưa nhập MNV EmpCode"},
    //     {
    //         pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
    //         message: "Chỉ cho phép nhập số"
    //     }],
    // },
    {
      type: INPUT,
      label: "Họ tên",
      name: "hoTen",
      disable: true,
      rules: [{ required: true, message: "Chưa nhập họ tên" }],
    },
    {
      type: DATE_DAY_INPUT,
      label: "Ngày sinh",
      name: "birthday",
      // optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
      disable: true,
      rules: [{ required: true, message: "Chưa nhập ngày sinh" }],
    },
    {
      type: COMBO_BOX,
      label: "Giới tính",
      name: "idGioiTinh",
      disable: true,
      options: listGender,
      rules: [{ required: true, message: "Chưa nhập giới tính" }],
    },
    {
      type: INPUT,
      label: "TK đăng nhập",
      name: "taiKhoanDangNhap",
      disable: true,
    },
    {
      type: AUTO_COMPLETE,
      label: "Người quản lý trực tiếp",
      name: "nguoiQuanLyTrucTiep",
      disable: true,
    },
    {
      type: INPUT,
      label: "Nơi sinh",
      name: "noiSinh",
      disable: true,
    },
    {
      type: INPUT,
      label: "Hộ khẩu",
      name: "hoKhau",
      disable: true,
      // placeholder: "Không có",
    },
    {
      type: COMBO_BOX,
      label: "Quốc tịch",
      name: "quocTich",
      expand: false,
      disable: true,
      onChange : handleQuocTich,
      // placeholder: "Không có",
    },
    {
      type: COMBO_BOX,
      label: "Tôn Giáo",
      name: "tonGiao",
      expand: false,
      disable: true,
    },
    {
      type: COMBO_BOX,
      label: "Dân tộc",
      name: "danToc",
      expand: false,
      disable: true,
    },
    {
      type: COMBO_BOX,
      label: "Quốc tịch TA",
      name: "quocTichTA",
      expand: false,
      disable: true,
      // placeholder: "Không có",
    },
    {
      type: COMBO_BOX,
      label: "TT hôn nhân",
      name: "tinhTrangHonNhan",
      disable: true,
      options: listMarriage,
    },
  
    {
      type: AUTO_COMPLETE,
      label: "Học vấn cao nhất",
      name: "hocVanCaoNhat",
      disable: true,
      options: [
        { value: "Đại học", label: "Đại học" },
        { value: "Cao Đẳng", label: "Cao Đẳng" },
      ],
    },
    {
      type: INPUT,
      label: "Trường",
      name: "truong",
      disable: true,
    },
    {
      type: INPUT,
      label: "Chuyên ngành",
      name: "chuyenNganh",
      disable: true,
      // options: [
      //   { value: "CNTT", label: "CNTT" },
      //   { value: "Quản Trị", label: "Quản Trị" },
      // ],
    },
    {
      type: INPUT,
      label: "ĐT di động",
      name: "dienThoaiDiDong",
      disable: true,
      placeholder: "Không có",
      // rules: [
      //   {
      //     validator: validatePhoneNumber,
      //    // required: false,
      //   },
      // ],
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
        {
          max: 11,
          min: 10,
          message: "Định dạng SĐT không đúng",
        },
      ],
    },
    {
      type: INPUT,
      label: "Email cá nhân",
      name: "emailCaNhan",
      disable: true,
      placeholder: "Không có",
      rules: [
        {
          pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
          message: "Định dạng email không đúng",
        },
      ],
    },
    {
      type: INPUT,
      label: "Chuyên ngành TA",
      name: "chuyenNganhTA",
      disable: true,
      // options: [
      //   { value: "CNTT", label: "CNTT" },
      //   { value: "Quản Trị", label: "Quản Trị" },
      // ],
    },
    {
      type: INPUT,
      label: "Email công ty",
      name: "emailCongTy",
      disable: true,
      // placeholder: "Không có",
      rules: [
        {
          pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
          message: "Định dạng email không đúng",
        },
      ],
    },
    {
      type: INPUT,
      label: "Số CCCD/CMT",
      name: "cccd",
      disable: true,
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
        {
          max: 12,
          min: 9,
          message: "Định dạng CCCD/CMT không đúng",
        },
      ],
      // placeholder: "Không có",
    },
    {
      type: DATE_DAY_INPUT,
      label: "Ngày cấp",
      name: "ngayCapDto",
      disable: true,
      placeholder: "Không có",
      // optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: COMBO_BOX,
      label: "Nơi cấp",
      name: "noiCap",
      disable: true,
      onChange : handleNoiCap,
      // placeholder: "Không có",
    },
    {
      type: INPUT,
      label: "Số người giảm trừ gia cảnh",
      name: "soNguoiPhuThuoc",
      disable: true,
      rules: [
        {
          pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
          message: "Chỉ cho phép nhập số",
        },
      ],
      // placeholder: "Không có",
    },
    {
      name: "idVaiTro",
      type: CHECKBOX,
      label: "Vai trò",
      disable: true,
      checkbox: [
        {
          label: "Bác sĩ",
          value: 1,
          span: 32,
        },
      ],
    },
    {
      type: COMBO_BOX,
      label: "Nơi cấp TA",
      name: "noiCapTA",
      disable: true,
      css: {
        xl: 16,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 4, xl: 3 },
      wrapperCol: { xs: 14, md: 16, lg: 20, xl: 21 },
      // placeholder: "Không có",
    },
    {
      type: INPUT,
      label: "ĐC thường trú",
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
      wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
      name: "diaChiThuongTru",
      disable: true,
    },
    {
      type: INPUT,
      label: "ĐC thường trú TA",
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
      wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
      name: "diaChiThuongTruTA",
      disable: true,
    },
    {
      type: INPUT,
      label: "ĐC liên hệ",
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
      wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
      name: "diaChiLienHe",
      disable: true,
    },
    {
      type: TEXT_AREA,
      label: "Ghi chú",
      css: {
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24,
      },
      labelCol: { xs: 10, md: 8, lg: 4, xl: 2 },
      wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },
      name: "ghiChu",
      disable: true,
    },
  
    {
      type: DATE_DAY_INPUT,
      label: "Ngày vào làm",
      name: "ngayVaoLam",
      disable: true,
      disableDate: false,
      placeholder: "Không có",
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: DATE_DAY_INPUT,
      label: "Ngày nghỉ việc",
      name: "ngayNghiViec",
      disable: true,
      disabledDate: false,
      placeholder: "Không có",
      optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
    },
    {
      type: INPUT,
      label: "Lý do nghỉ",
      name: "lyDoNghiViec",
      disable: true,
      // placeholder: "Không có",
    },
  ];
  const employeesStore = useAppSelector(
    (state) => state.employeesReducer.employee
  );
  const employeeMode = useAppSelector(
    (state) => state.employeesReducer.employeeMode
  );
  const [formTable] = Form.useForm();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileInputRef1 = useRef<HTMLInputElement>(null);
  const fileInputRef2 = useRef<HTMLInputElement>(null);
  const fileInputRef3 = useRef<HTMLInputElement>(null);
  const fileInputRef4 = useRef<HTMLInputElement>(null);
  const fileInputRef5 = useRef<HTMLInputElement>(null);
  const fileInputRef6 = useRef<HTMLInputElement>(null);
  const fileInputRef7 = useRef<HTMLInputElement>(null);
  const fileInputRef8 = useRef<HTMLInputElement>(null);
  const fileInputRef9 = useRef<HTMLInputElement>(null);
  const fileInputRef10 = useRef<HTMLInputElement>(null);
  const fileInputRef11 = useRef<HTMLInputElement>(null);
  const fileInputRef12 = useRef<HTMLInputElement>(null);
  const [imageId, setImageId] = useState<string | null>(null);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const showHeader = true;
  const [data, setData] = useState<any>([]);
  const dataRef = useRef<any>([]);
  let status = useAppSelector((state) => state.employeesReducer.status);
  const dispatch = useAppDispatch();
  const activeTabKey = useAppSelector((state) => state.common.activeTab);
  const [listButton, setListButton] = useState<any[]>([]);
  let id = useAppSelector((state) => state.employeesReducer.idEmp);
  const [isStatus, setIsStatus] = useState(true);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  let type = useAppSelector((state) => state.employeesReducer.type);

  const employees = useAppSelector((state) => state.employeesReducer);
  const [fieldInfo, setFieldInfo] = useState(InfoMapOptions);
  const [fieldStates, setFieldStates] = useState(fields);
  const [fieldContact, setFieldContact] = useState(columnsTable);

  const dataSYLLIdRef = useRef(null);
  const dataLLTPIdRef = useRef(null);
  const dataGKSIdRef = useRef(null);
  const dataGKSKIdRef = useRef(null);
  const dataTCCIdRef = useRef(null);
  const dataXNTCIdRef = useRef(null);
  const dataBCIdRef = useRef(null);
  const dataXNTAIdRef = useRef(null);
  const dataKSCIdRef = useRef(null);
  const dataCCHNIdRef = useRef(null);
  const dataNHIdRef = useRef(null);
  const dataKhacIdRef = useRef(null);
  const [dataSYLLId, setSYLLId] = useState(null);
  const [dataLLTPId, setLLTPId] = useState(null);
  const [dataGSKId, setGSKId] = useState(null);
  const [dataGKSKId, setGKSKId] = useState(null);
  const [dataTCCId, setTCCId] = useState(null);
  const [dataXNTCId, setXNTCId] = useState(null);
  const [dataBCId, setBCId] = useState(null);
  const [dataTAId, setTAId] = useState(null);
  const [dataKSCId, setKSCId] = useState(null);
  const [dataCCHNId, setCCHNId] = useState(null);
  const [dataHNId, setHNId] = useState(null);
  const [dataKhacId, setKhacId] = useState(null);
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const handleSave = async (d) => {
    setLoading(true);
    // const data = formTable.getFieldsValue();
    await form.validateFields(["hoTen", "birthday", "idGioiTinh", "empCode"]);
    const value = form.getFieldsValue();
    try {
      const newValue = {
        ...value,
        id: id,
        anh: value?.anh,
        listThanNhanDto: dataRef?.current,
        ngayCapDto: formatDateToString(value.ngayCapDto, FORMAT_TIME.dayFull),
        birthday: formatDateToString(value.birthday, FORMAT_TIME.dayFull),
        fileSoYeuLyLichChungNhanPhuongXa: dataSYLLIdRef?.current,
        fileLyLichTuPhap: dataLLTPIdRef?.current,
        fileGiayKhaiSinh: dataGKSIdRef?.current,
        fileGiayKhamSucKhoe: dataGKSKIdRef?.current,
        fileCMNDCMTCongChung: dataTCCIdRef?.current,
        fileGiayXacNhanThuongTruCuaCongAn: dataXNTCIdRef?.current,
        fileBangCap: dataBCIdRef?.current,
        fileXacNhanCongAnKhongTienAnTienSu: dataXNTAIdRef?.current,
        fileGiayKhaiSinhCon: dataKSCIdRef?.current,
        fileChungChiHanhNghe: dataCCHNIdRef?.current,
        fileQuyetDinhNghiViecNghiHuu: dataNHIdRef?.current,
        fileKhac: dataKhacIdRef?.current,
      };
      const res = await employeeService.updateDetailsEmployee(newValue);
      if (res.code == 200) {
        if (status !== true && activeTabKey !== tabKeys.EMPLOYEE.DETAIL) {
          // newId();
          form.resetFields();
        }
        Notification("success", res.message);
        dispatch(setIdEmployee(res.data.id)); // set current employee id after created
      } else {
        Notification("error", res.message);
      }
      setLoading(false);
    } catch (res) {
      setLoading(false);
      Notification("error", res.message);
    }
  };
  const handleCancel = () => {
    dispatch(setAdd(false));
    const updatedFieldContact = fieldContact.map((field) => ({
      ...field,
      disable: field.disable == false ? true : field.disable,
    }));
    const updatedFieldInfo = fieldInfo.map((field) => ({
      ...field,
      disable: field.disable == false ? true : field.disable,
    }));
    setIsStatus(true);
    const updatedFields = fieldStates.map((field) => ({
      ...field,
      disable: field.disable == false ? true : field.disable,
    }));
    setFieldStates(updatedFields);
    setFieldContact(updatedFieldContact);
    setFieldInfo(updatedFieldInfo);
    setListButton([edit(toggleDisable)]);
    setIsButtonVisible(false);

    getDetailsEmployee(id);
  };
  useEffect(() => {
    dispatch(
      searchEmployeeAPI({
        page: 1,
        limit: 100,
      })
    );
    dispatch(getDanToc());
    dispatch(getNation());
    dispatch(getTonGiao());
    dispatch(getBank());
    dispatch(getNoiCap());
  }, []);
  useEffect(() => {
    setOptionsEmpFields(employees.employeesList, "nguoiQuanLyTrucTiep");
  }, [employees.employeesList]);
  useEffect(() => {
    setOptionsBankFields(employees.BankList, "nganHang");
  }, [employees.BankList]);
  useEffect(() => {
    setOptionsTGFields(employees.tonGiaoList, "tonGiao");
  }, [employees.tonGiaoList]);

  useEffect(() => {
    setOptionsQTFields(employees.quocTichList, "quocTich");
  }, [employees.quocTichList]);
  //
  useEffect(() => {
    setOptionsSearchFields(employees.danTocList, "danToc");
  }, [employees.danTocList]);
  useEffect(() => {
    setOptionsNoiCap(employees.noiCap, "noiCap");
  }, [employees.noiCap]);
  const setOptionsNoiCap = (list, noiCap) => {
    if (fieldStates.find((field) => field.name === noiCap)) {
      fieldStates.find((field) => field.name === noiCap).options = list?.map(
        (item) => ({
          value: item.noiCap,
          label: item.noiCap,
        })
      );
      setFieldStates([...fieldStates]);
    }
  };
  const setOptionsBankFields = (list, tenNganHang) => {
    if (fieldInfo.find((field) => field.name === tenNganHang)) {
      fieldInfo.find((field) => field.name === tenNganHang).options = list?.map(
        (item) => ({
          value: item.tenNganHang,
          label: item.tenNganHang,
        })
      );
      setFieldInfo([...fieldInfo]);
    }
  };
  const setOptionsEmpFields = (list, hoTen) => {
    if (fieldStates.find((field) => field.name === hoTen)) {
      fieldStates.find((field) => field.name === hoTen).options = list?.map(
        (item) => ({
          value: item.hoTen,
          label: item.hoTen,
        })
      );
      setFieldStates([...fieldStates]);
    }
  };
  const setOptionsTGFields = (list, name) => {
    if (fieldStates.find((field) => field.name === name)) {
      fieldStates.find((field) => field.name === name).options = list?.map(
        (item) => ({
          value: item.name,
          label: item.name,
        })
      );
      setFieldStates([...fieldStates]);
    }
  };
  const setOptionsSearchFields = (list, name) => {
    if (fieldStates.find((field) => field.name === name)) {
      fieldStates.find((field) => field.name === name).options = list?.map(
        (item) => ({
          value: item.name,
          label: item.name,
        })
      );
      setFieldStates([...fieldStates]);
    }
  };
  const setOptionsQTFields = (list, nameVN) => {
    if (fieldStates.find((field) => field.name === nameVN)) {
      fieldStates.find((field) => field.name === nameVN).options = list?.map(
        (item) => ({
          value: item.nameVN,
          label: item.nameVN,
        })
      );
      setFieldStates([...fieldStates]);
    }
  };
  const getDetailsEmployee = async (id) => {
    if (id) {
      setLoading(true);
      try {
        const res = await employeeService.getEmployee(id);
        dispatch(setEmployee(res));
        setImageId(res?.anh);
        setData(res?.listThanNhanDto);
        setSYLLId(res?.fileSoYeuLyLichChungNhanPhuongXaDto?.id);
        setLLTPId(res?.fileLyLichTuPhapDto?.id);
        setGSKId(res?.fileGiayKhaiSinhDto?.id);
        setGKSKId(res?.fileGiayKhamSucKhoeDto?.id);
        setTCCId(res?.fileCMNDCMTCongChungDto?.id);
        setXNTCId(res?.fileGiayXacNhanThuongTruCuaCongAnDto?.id);
        setBCId(res?.fileBangCapDto?.id);
        setTAId(res?.fileXacNhanCongAnKhongTienAnTienSuDto?.id);
        setKSCId(res?.fileGiayKhaiSinhConDto?.id);
        setCCHNId(res?.fileChungChiHanhNgheDto?.id);
        setHNId(res?.fileQuyetDinhNghiViecNghiHuuDto?.id);
        setKhacId(res?.fileKhacDto?.id);
        form.setFieldValue(
          "fileSoYeuLyLichChungNhanPhuongX",
          res?.fileSoYeuLyLichChungNhanPhuongXaDto?.tenFile
        );
        form.setFieldValue("fileLyLichTuP", res?.fileLyLichTuPhapDto?.tenFile);
        form.setFieldValue("fileGiayKhaiS", res?.fileGiayKhaiSinhDto?.tenFile);
        form.setFieldValue(
          "fileGiayKhamSucK",
          res?.fileGiayKhamSucKhoeDto?.tenFile
        );
        form.setFieldValue(
          "fileCMNDCMTCongC",
          res?.fileCMNDCMTCongChungDto?.tenFile
        );
        form.setFieldValue(
          "fileGiayXacNhanThuongTruCuaCA",
          res?.fileGiayXacNhanThuongTruCuaCongAnDto?.tenFile
        );
        form.setFieldValue("fileBangC", res?.fileBangCapDto?.tenFile);
        form.setFieldValue(
          "fileXacNhanCongAnKhongTienAnTienS",
          res?.fileXacNhanCongAnKhongTienAnTienSuDto?.tenFile
        );
        form.setFieldValue(
          "fileGiayKhaiSinhC",
          res?.fileGiayKhaiSinhConDto?.tenFile
        );
        form.setFieldValue(
          "fileChungChiHanhN",
          res?.fileChungChiHanhNgheDto?.tenFile
        );
        form.setFieldValue(
          "fileQuyetDinhNghiViecNghi",
          res?.fileQuyetDinhNghiViecNghiHuuDto?.tenFile
        );
        form.setFieldValue("fileKh", res?.fileKhacDto?.tenFile);
        dataSYLLIdRef.current = res?.fileSoYeuLyLichChungNhanPhuongXa;
        dataLLTPIdRef.current = res?.fileLyLichTuPhap;
        dataGKSIdRef.current = res?.fileGiayKhaiSinh;
        dataGKSKIdRef.current = res?.fileGiayKhamSucKhoe;
        dataTCCIdRef.current = res?.fileCMNDCMTCongChung;
        dataXNTCIdRef.current = res?.fileGiayXacNhanThuongTruCuaCongAn;
        dataBCIdRef.current = res?.fileBangCap;
        dataXNTAIdRef.current = res?.fileXacNhanCongAnKhongTienAnTienSu;
        dataKSCIdRef.current = res?.fileGiayKhaiSinhCon;
        dataCCHNIdRef.current = res?.fileChungChiHanhNghe;
        dataNHIdRef.current = res?.fileQuyetDinhNghiViecNghiHuu;
        dataKhacIdRef.current = res?.fileKhac;
        setLoading(false);
      } catch (error) {
        setLoading(false);
        Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
      }
    } else {
      if (status == true) {
        setLoading(false);
        form.resetFields();
      } else {
        Notification(
          "warning",
          "Tìm kiếm và chọn nhân viên để xem chi tiết thông tin"
        );
        setLoading(true);
      }
    }
  };
  useEffect(() => {
    if (status == true && activeTabKey === tabKeys.EMPLOYEE.DETAIL) {
      const updatedFieldContact = fieldContact.map((field) => ({
        ...field,
        disable: false,
      }));
      const updatedFieldInfo = fieldInfo.map((field) => ({
        ...field,
        disable: false,
      }));
      const updatedFields = fieldStates.map((field) => {
        if (field.name === "ngayNghiViec" || field.name === "lyDoNghiViec" || field.name === "quocTichTA" || field.name === "noiCapTA") {
          return {
            ...field,
            disable: true,
          };
        } else {
          return {
            ...field,
            disable: false,
          };
        }
      });
      setFieldStates(updatedFields);
      setFieldContact(updatedFieldContact);
      setFieldInfo(updatedFieldInfo);
      setListButton([Cancel(handleCancel), Save(handleSave)]);
      setIsButtonVisible(true);
      if (id !== null) {
        getDetailsEmployee(id);
      } else {
        // newId()
        form.resetFields();
        setData([]);
      }
    } else {
      const updatedFieldContact = fieldContact.map((field) => ({
        ...field,
        disable: field.disable == false ? true : field.disable,
      }));
      const updatedFieldInfo = fieldInfo.map((field) => ({
        ...field,
        disable: field.disable == false ? true : field.disable,
      }));
      setIsStatus(true);
      const updatedFields = fieldStates.map((field) => ({
        ...field,
        disable: field.disable == false ? true : field.disable,
      }));
      setFieldStates(updatedFields);
      setFieldContact(updatedFieldContact);
      setFieldInfo(updatedFieldInfo);
      if (activeTabKey === tabKeys.EMPLOYEE.DETAIL) {
        setListButton([edit(toggleDisable)]);
        setIsButtonVisible(false);
      } else {
        setListButton([]);
        setIsButtonVisible(false);
      }
    }
    // if (activeTabKey !== tabKeys.EMPLOYEE.DETAIL) {
    //   setListButton([]);
    //   setIsButtonVisible(false);
    // }
  }, [status, id, activeTabKey]);
  useEffect(() => {
    getDetailsEmployee(id);
  }, [id]);
  const [dataSYLL, setSYLL] = useState(dataSoYeuLyLich);
  const [dataLLTP, setLLTP] = useState(dataLyLichTuPhap);
  const [dataGKS, setGKS] = useState(dataGiayKhaiSinh);
  const [dataGKSK, setGKSK] = useState(dataGiayKhamSucKhoe);
  const [dataTCC, setTCC] = useState(dataTheCanCuoc);
  const [dataXNTC, setXNTC] = useState(dataXacNhanThuongChu);
  const [dataBC, setBC] = useState(dataBangCap);
  const [dataXNTA, setXNTA] = useState(dataXacNhanTienAn);
  const [dataKSC, setKSC] = useState(dataKhaiSinhCon);
  const [dataCCHN, setCCHN] = useState(dataChungChiHanhNghe);
  const [dataNH, setNH] = useState(dataNghiHuu);
  const [dataKh, setKh] = useState(dataKhac);
  const { isNhanVien, isQuanLy, isGiamDoc } = usePermission();
  const toggleDisable = () => {
    dispatch(setAdd(true));
    const updatedFieldContact = fieldContact.map((field) => ({
      ...field,

      disable: isNhanVien() || isQuanLy() || isGiamDoc(),
    }));
    const updatedFieldInfo = fieldInfo.map((field) => ({
      ...field,
      disable: isNhanVien() || isQuanLy() || isGiamDoc(),
    }));
    const updatedFields = fieldStates.map((field) => {
      if (
        field.name === "ngayNghiViec" ||
        field.name === "lyDoNghiViec" ||
        field.name === "maNhanVien" || field.name === "quocTichTA" || field.name === "noiCapTA"
      ) {
        return {
          ...field,
          disable: true,
        };
      } else {
        return {
          ...field,
          disable: false,
        };
      }
    });
    setFieldStates(updatedFields);
    setFieldContact(updatedFieldContact);
    setFieldInfo(updatedFieldInfo);
    setListButton([Cancel(handleCancel), Save(handleSave)]);
    setIsButtonVisible(true);
  };
  useEffect(() => {
    form.setFieldsValue({
      ...employeesStore,
      ngayCapDto: employeesStore?.ngayCapDto
        ? dayjs(employeesStore.ngayCapDto, "DD/MM/YYYY")
        : null,
      tuoi: employeesStore?.birthday
        ? moment().year() - dayjs(employeesStore.birthday, "DD/MM/YYYY").year()
        : null,
      birthday: employeesStore?.birthday
        ? dayjs(employeesStore.birthday, "DD/MM/YYYY")
        : null,
      ngayVaoLam: employeesStore?.ngayVaoLam
        ? dayjs(employeesStore.ngayVaoLam)
        : null,
      ngayNghiViec: employeesStore?.ngayNghiViec
        ? dayjs(employeesStore.ngayNghiViec)
        : null,
      ngayCapSoTaiKhoanNganHang: employeesStore?.ngayCapSoTaiKhoanNganHang
        ? dayjs(employeesStore.ngayCapSoTaiKhoanNganHang)
        : null,
    });
  }, [employeesStore]);
  useEffect(() => {
    dispatch(setButtonsHeader([listButton]));
  }, [listButton]);
  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const image = event.target.files[0];

      const formData = new FormData();
      formData.append("imageFile", image);
      try {
        const response = await medicalExaminationService.uploadImage(formData);
        if (response.status == 200) {
          setImageId(response.data.imageId);
          //setHaveImage(true);
        }
      } catch (err) {
        Notification("error", "Lỗi khi tải lên ảnh");
      }
    }
  };
  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleClick1 = () => {
    if (fileInputRef1.current) {
      fileInputRef1.current.click();
    }
  };
  const handleClick2 = () => {
    if (fileInputRef2.current) {
      fileInputRef2.current.click();
    }
  };
  const handleClick3 = () => {
    if (fileInputRef3.current) {
      fileInputRef3.current.click();
    }
  };
  const handleClick4 = () => {
    if (fileInputRef4.current) {
      fileInputRef4.current.click();
    }
  };
  const handleClick5 = () => {
    if (fileInputRef5.current) {
      fileInputRef5.current.click();
    }
  };
  const handleClick6 = () => {
    if (fileInputRef6.current) {
      fileInputRef6.current.click();
    }
  };
  const handleClick7 = () => {
    if (fileInputRef7.current) {
      fileInputRef7.current.click();
    }
  };
  const handleClick8 = () => {
    if (fileInputRef8.current) {
      fileInputRef8.current.click();
    }
  };
  const handleClick9 = () => {
    if (fileInputRef9.current) {
      fileInputRef9.current.click();
    }
  };
  const handleClick10 = () => {
    if (fileInputRef10.current) {
      fileInputRef10.current.click();
    }
  };
  const handleClick11 = () => {
    if (fileInputRef11.current) {
      fileInputRef11.current.click();
    }
  };
  const handleClick12 = () => {
    if (fileInputRef12.current) {
      fileInputRef12.current.click();
    }
  };
  useEffect(() => {
    if (imageId) form.setFieldValue("anh", imageId);
  }, [imageId]);
  const handleUploadSYLL = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 1)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileSoYeuLyLichChungNhanPhuongX", pdf.name);
          // setSYLLId(response.data.id);
          dataSYLLIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadLLTP = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 2)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileLyLichTuP", pdf.name);
          dataLLTPIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadGKS = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 3)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileGiayKhaiS", pdf.name);
          dataGKSIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadGKSK = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 4)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileGiayKhamSucK", pdf.name);
          dataGKSKIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadTCC = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 5)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileCMNDCMTCongC", pdf.name);
          dataTCCIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadXNTC = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 6)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileGiayXacNhanThuongTruCuaCA", pdf.name);
          dataXNTCIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadBC = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 7)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileBangC", pdf.name);
          dataBCIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadTA = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 8)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileXacNhanCongAnKhongTienAnTienS", pdf.name);
          dataXNTAIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadKSC = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 9)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileGiayKhaiSinhC", pdf.name);
          dataKSCIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadCCHN = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 10)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileChungChiHanhN", pdf.name);
          dataCCHNIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadNH = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 11)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileQuyetDinhNghiViecNghi", pdf.name);
          dataNHIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleUploadKhac = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLoading(true);
    if (event.target.files && event.target.files.length > 0) {
      const pdf = event.target.files[0];

      const formData = new FormData();
      formData.append("file", pdf);
      try {
        if (id === null) {
          Notification("warning", "Vui lòng lưu nhân viên trước khi upload");
          setLoading(false);
        } else {
          const response = await employeeService.uploadFileEmployee(
            formData,
            id,
            (type = 12)
          );
          if (response.status == 200) {
          }
          setLoading(false);
          form.setFieldValue("fileKh", pdf.name);
          dataKhacIdRef.current = response.data.id;
          Notification("success", "tải lên file thành công");
        }
      } catch (err) {
        setLoading(false);
        Notification("error", "Lỗi khi tải lên file");
      }
    }
  };
  const handleDownload1 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataSYLLId}`;
    const baseName = form.getFieldValue("fileSoYeuLyLichChungNhanPhuongX");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload2 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataLLTPId}`;
    const baseName = form.getFieldValue("fileLyLichTuP");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload3 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataGSKId}`;
    const baseName = form.getFieldValue("fileGiayKhaiS");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload4 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataGKSKId}`;
    const baseName = form.getFieldValue("fileGiayKhamSucK");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload5 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataTCCId}`;
    const baseName = form.getFieldValue("fileCMNDCMTCongC");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload6 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataXNTCId}`;
    const baseName = form.getFieldValue("fileGiayXacNhanThuongTruCuaCA");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload7 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataBCId}`;
    const baseName = form.getFieldValue("fileBangC");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload8 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataTAId}`;
    const baseName = form.getFieldValue("fileXacNhanCongAnKhongTienAnTienS");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload9 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataKSCId}`;
    const baseName = form.getFieldValue("fileGiayKhaiSinhC");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload10 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataCCHNId}`;
    const baseName = form.getFieldValue("fileChungChiHanhN");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload11 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataHNId}`;
    const baseName = form.getFieldValue("fileQuyetDinhNghiViecNghi");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };
  const handleDownload12 = async () => {
    const url = `hanhchinhnhansu/file/view?id=${dataKhacId}`;
    const baseName = form.getFieldValue("fileKh");
    const fileExtension = "pdf";
    const fileName = generateFileName(baseName, fileExtension);
    // const params = {
    //   id: data.id,
    // };

    try {
      const response = await axiosClient.get(url, {
        responseType: "blob",
        // headers: {
        //   Authorization: `Bearer YOUR_TOKEN`, // Replace with your actual authentication token
        // },
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      if (error.response && error.response.status === 401) {
        // Unauthorized, handle accordingly (e.g., redirect to login)
        Notification("error", "Không được phép. Vui lòng hãy đăng nhập.");
      } else {
        Notification("error", "Không có file pdf");
      }
    }
  };

  const disableUploadFields = useMemo(() => {
    return employeeMode === EMPLOYEE_MODE.VIEW;
  }, [employeeMode]);

  return (
    // <Spin spinning={loading}>
    <Form form={form}>
      <Space direction="vertical">
        <div className="detail-diagnose" style={{ textAlign: "left" }}>
          <div className="container">
            <div className="header">Thông tin cá nhân</div>
            <div className="container-main">
              <Row gutter={[16, 0]}>
                <Col className="avatar" flex="150px">
                  <Form.Item name={"anh"}>
                    {imageId !== null &&
                      imageId !== "" &&
                      imageId !== undefined && (
                        <Image
                          width={140}
                          height={"auto"}
                          src={getImageSrc(imageId)}
                          preview={false}
                        />
                      )}

                    {!(
                      imageId !== null &&
                      imageId !== "" &&
                      imageId !== undefined
                    ) && (
                      <Avatar
                        icon={<UserOutlined />}
                        shape="square"
                        size={140}
                      />
                    )}
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUpload}
                      ref={fileInputRef}
                    />
                    {isButtonVisible && (
                      <Button
                        icon={<Icons.upload />}
                        className="btn-upload"
                        type="dashed"
                        onClick={handleClick}
                        style={{
                          width: "140px",
                          // border: "1px solid #00B335", // Đặt màu viền xanh
                          color: "#b2aeb1", // Đặt màu chữ xanh tương ứng
                        }}
                      >
                        Thay đổi ảnh
                      </Button>
                    )}
                  </Form.Item>
                </Col>
                <Col flex={"1 0 0"}>
                  <Space direction="vertical" size={"middle"}>
                    {showHeader && (
                      <Row gutter={[16, 8]}>
                        <Form.Item
                          initialValue={null}
                          className="form"
                          name="hoTenBN"
                          style={{ fontWeight: "bold" }}
                        >
                          {(employeesStore?.hoTen ||
                            employeesStore?.hoTenBN ||
                            employeesStore?.hoVaTen ||
                            employeesStore?.tenBenhNhan) ??
                            "Không có"}{" "}
                          -
                        </Form.Item>
                        <Form.Item
                          initialValue={null}
                          className="form"
                          style={{ fontWeight: "bold" }}
                          name="gioiTinh"
                        >
                          &nbsp;
                          {employeesStore?.idGioiTinh === 1
                            ? "Nữ"
                            : employeesStore?.idGioiTinh === 0
                            ? "Nam"
                            : "Không có"}{" "}
                          -
                        </Form.Item>

                        <Form.Item
                          initialValue={null}
                          name="birthday"
                          style={{ fontWeight: "bold" }}
                          className="form"
                        >
                          &nbsp;
                          {employeesStore?.birthday
                            ? moment().diff(
                                moment(employeesStore?.birthday, "DD/MM/YYYY"),
                                "years"
                              )
                            : ""}
                          &nbsp; Tuổi&nbsp; (SN:&nbsp;
                          {employeesStore
                            ? moment(
                                employeesStore?.birthday,
                                "DD/MM/YYYY"
                              ).format("DD/MM/YYYY")
                            : "Không có"}
                          )
                        </Form.Item>
                      </Row>
                    )}

                    <Row gutter={[16, 16]}>
                      <InputFields data={fieldStates} />
                    </Row>
                  </Space>
                </Col>
              </Row>
            </div>
          </div>
          <div className="container">
            <TypographyCommon title={"Số tài khoản và bảo hiểm"} />
            <Row gutter={[16, 16]}>
              <InputFields data={fieldInfo} />
            </Row>
          </div>
          <div className="container">
            <TypographyCommon title={"Thông tin thân nhân"} />
            <Form form={formTable}>
              <TableInputAdd
                //loading={loading}
                column={columnsTable}
                data={data}
                setData={setData}
                pagination={false}
                form={formTable}
                name="test"
                // rowSelection={{
                //   type: "checkbox",
                //   onChange: onSelectRow,
                //   selectedRowKeys: selectedRowKeys,
                // }}
              />
            </Form>
          </div>
          <div className="container">
            <TypographyCommon title={"Hồ sơ cá nhân"} />
            <Row gutter={[16, 16]}>
              <InputFields data={dataSYLL} />
              <Col>
                <input
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleUploadSYLL}
                  ref={fileInputRef1}
                  accept=".pdf"
                />
                <Button
                  icon={<Icons.upload />}
                  className="btn-upload"
                  type="dashed"
                  onClick={handleClick1}
                  style={{
                    marginRight: "10px",
                    width: "120px",
                    marginBottom: "10px",
                    border: "1px solid #000101", // Đặt màu viền xanh
                    color: "#050e08", // Đặt màu chữ xanh tương ứng
                  }}
                  disabled={disableUploadFields}
                >
                  Upload
                </Button>
                <Button
                  icon={<DownloadOutlined />}
                  onClick={handleDownload1}
                  style={{
                    //  marginRight: "10px",
                    width: "120px",
                    border: "1px solid #000101", // Đặt màu viền xanh
                    color: "#050e08", // Đặt màu chữ xanh tương ứng
                  }}
                >
                  Tải xuống
                </Button>
              </Col>
              <InputFields data={dataLLTP} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadLLTP}
                    ref={fileInputRef2}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick2}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload2}
                    style={{
                      // marginRight: "10px",
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataGKS} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadGKS}
                    ref={fileInputRef3}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick3}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined  />}
                    onClick={handleDownload3}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataGKSK} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadGKSK}
                    ref={fileInputRef4}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload  />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick4}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload4}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataTCC} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadTCC}
                    ref={fileInputRef5}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload  />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick5}
                    style={{
                      marginRight: "10px",
                      marginBottom: "10px",
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload5}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataXNTC} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadXNTC}
                    ref={fileInputRef6}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick6}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload6}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataBC} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadBC}
                    ref={fileInputRef7}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick7}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload7}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataXNTA} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadTA}
                    ref={fileInputRef8}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload  />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick8}
                    style={{
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload8}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataKSC} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadKSC}
                    ref={fileInputRef9}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick9}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined  />}
                    onClick={handleDownload9}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataCCHN} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadCCHN}
                    ref={fileInputRef10}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick10}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload10}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataNH} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadNH}
                    ref={fileInputRef11}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick11}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload11}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
              <InputFields data={dataKh} />
              <Col>
                <Tooltip title={"Upload "}>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleUploadKhac}
                    ref={fileInputRef12}
                    accept=".pdf"
                  />
                  <Button
                    icon={<Icons.upload />}
                    className="btn-upload"
                    type="dashed"
                    onClick={handleClick12}
                    style={{
                      marginRight: "10px",
                      width: "120px",
                      marginBottom: "10px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                    disabled={disableUploadFields}
                  >
                    Upload
                  </Button>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={handleDownload12}
                    style={{
                      width: "120px",
                      border: "1px solid #000101", // Đặt màu viền xanh
                      color: "#050e08", // Đặt màu chữ xanh tương ứng
                    }}
                  >
                    Tải xuống
                  </Button>
                </Tooltip>
              </Col>
            </Row>
          </div>
        </div>
      </Space>
    </Form>
    // </Spin>
  );
};
export default Detail;
